export const setCssVariable = (element, key, value) => {
  if (element) {
    element.style.setProperty(key, value);
  }
};

export const setStatusClass = name => {
  const statusAsClass = {
    "In Progress": "blue",
    "Meeting Goal": "blue",
    "Not Meeting Goal": "danger",
    "Not Started": "danger",
    Cancelled: "dark",
    Completed: "success",
    Scheduled: "blue",
    "On Hold": "dark"
  };
  return statusAsClass[name];
};
